'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dSigner$002dRole$0024 from "./presto.types$-Signer-Role$.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_envelopes_EnvelopesView$$anon$3(outer) {
  this.bUy = null;
  this.bUw = null;
  this.bUx = false;
  this.bUu = null;
  this.bUv = false;
  this.bUz = false;
  this.bUA = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bUy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_envelopes_EnvelopesView$$anon$3 as $c_Lpresto_pages_envelopes_EnvelopesView$$anon$3 };
$p = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$3;
/** @constructor */
function $h_Lpresto_pages_envelopes_EnvelopesView$$anon$3() {
}
export { $h_Lpresto_pages_envelopes_EnvelopesView$$anon$3 as $h_Lpresto_pages_envelopes_EnvelopesView$$anon$3 };
$h_Lpresto_pages_envelopes_EnvelopesView$$anon$3.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bUy;
});
$p.t = (function() {
  if ((!this.bUx)) {
    this.bUw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("cpf", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("role", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("certificate", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bUx = true;
  }
  return this.bUw;
});
$p.ae = (function() {
  if ((!this.bUv)) {
    this.bUu = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().p8(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSigner$002dRole$0024.$m_Lpresto_types$SignerRole$().cIo(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().iZ, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())))));
    this.bUv = true;
  }
  return this.bUu;
});
$p.w = (function() {
  if ((!this.bUA)) {
    this.bUz = false;
    this.bUA = true;
  }
  return this.bUz;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_envelopes_EnvelopesView$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_envelopes_EnvelopesView$$anon$3, "presto.pages.envelopes.EnvelopesView$$anon$3", ({
  WA: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_envelopes_EnvelopesView$$anon$3 as $d_Lpresto_pages_envelopes_EnvelopesView$$anon$3 };
//# sourceMappingURL=presto.pages.envelopes.-Envelopes-View$$anon$3.js.map
